<template>
    <b-sidebar
        id="destination-form-sidebar"
        :visible="isDestinationFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(destinationData)"
        @hidden="resetForm(resetData)"
        @change="(val) => $emit('update:is-destination-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
                <h5 class="mb-0">
                    Destination Form
                </h5>
        
                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="hide"
                />
            </div>
            <validation-observer
                #default="{ handleSubmit }"
                ref="refFormObserver"
            >
                <b-form
                    class="p-2"
                    @submit.prevent="handleSubmit(onSubmit)"
                    @reset.prevent="resetForm"
                >
                    <b-tabs content-class="mt-1" v-if="langs.length > 0">
                        <b-tab v-for="(lang,key) in langs" :key="'tab-'+key"  :title="lang.name">
                            <validation-provider
                                #default="validationContext"
                                :name="'title_'+lang.code"
                                rules="min:0"
                            >
                                <b-form-group
                                    label="Destination"
                                    :label-for="'title_'+lang.code"
                                >
                                    <b-form-input
                                        :id="'title_'+lang.code"
                                        v-model="Data.title[lang.code]"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'destination ('+lang.code+')'"
                                        @input="changeTitle(lang.code)"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                :name="'slug' + lang.code"
                                rules="required"
                            >
                                <b-form-group
                                    label="Slug"
                                    :label-for="'slug' + lang.code"
                                >
                                    <b-form-input
                                        :id="'slug' + lang.code"
                                        v-model="Data.slug[lang.code]"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="'Slug (' + lang.code + ')'"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-tab>
                    </b-tabs>
                    <validation-provider
                        #default="validationContext"
                        name="IsActive"
                        rules="min:0"
                    >
                        <b-form-group
                            label="Is Active"
                            label-for="IsActive"
                        >
                            <b-form-checkbox
                                id="isactive"
                                checked="true"
                                class="custom-control-success"
                                v-model="Data.is_active"
                                switch
                            />
                            <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                    <div class="d-flex mt-2">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="mr-2"
                            type="submit"
                        >
                            Submit
                        </b-button>
                        <b-button
                            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            type="button"
                            variant="outline-secondary"
                            @click="hide"
                        >
                            Cancel
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>

<script>
import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,BTabs,BTab
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref,onUnmounted } from '@vue/composition-api'
import { required, alphaNum, email, password,confirmed } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import { slugify } from '@/@fake-db/utils'

import languagesStoreModule from '@/views/languages/languagesStoreModule'

export default {
    components: {
        BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton, vSelect,
        BTabs, BTab, ValidationProvider, ValidationObserver,
    },

    directives: {
        Ripple,
    },

    model: {
        prop: 'isDestinationFormSidebarActive',
        event: 'update:is-destination-form-sidebar-active',
    },

    props: {
        isDestinationFormSidebarActive: {
            type: Boolean,
            required: true,
        },
        destinationData: {
            type: Object,
            required: false,
        },
    },

    setup(props, { emit }) {
        const {  appRef } = $themeConfig.app

        const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
        if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)
        onUnmounted(() => {
            if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
        });

        const userStorage = JSON.parse(localStorage.getItem('userData'));
        const getLocalSite = JSON.parse(localStorage.getItem('site'))

        const blankData = {
            slug: {},
            title: {},
            is_active: true,
            ordering_count: 0,
            sites_id: getLocalSite.id,
            created_by: userStorage.id
        }

        const toast = useToast()
        const langs = ref([]);
        const Data = ref(blankData)

        const resetData = () => {
            Data.value = blankData
        }

        const getData = (data) => {
            if(data) {
                data.is_active = data.is_active?true:false
                return Data.value  = data
            }

            Data.value = blankData
        }

        const onSubmit = async () => {
            if(!Data.value.id){
                store.dispatch('app-review/addDestination', Data.value)
                    .then((res) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                            title: `Success`,
                            icon: 'BellIcon',
                            variant: 'success',
                            text: `${res?.data?.message}`,
                            },
                        });
                        
                        emit('refetch-data')
                        emit('update:is-destination-form-sidebar-active', false)
                    })
                    .catch((error) => {
                        toast({
                            component: ToastificationContent,
                            props: {
                                title: "Error fetching Destination' list",
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: `${error?.response?.data?.message??'Something went wrong'}`,
                            },
                        })
                    })
            } else {
                store.dispatch('app-review/updateDestination', Data.value)
                    .then((res) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                            title: `Success`,
                            icon: 'BellIcon',
                            variant: 'success',
                            text: `${res.data.message}`,
                            },
                        });
                        emit('refetch-data')
                        emit('update:is-destination-form-sidebar-active', false)
                    })
                    .catch((error) => {
                        toast({
                            component: ToastificationContent,
                            props: {
                                title: "Error fetching Destination' list",
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: error.response.data.message,
                            },
                        })
                    })
            }
        }

        const changeTitle  = (lang) => {
            if(lang){
                Data.value.slug[lang] = slugify(Data.value.title[lang]);
            }
        }

        const getLangs = (filter)=>{
            store.dispatch('app-languages/fetchData', filter)
                .then((res) => {
                    if(res.data.success){
                        langs.value = res.data.data;
                    }  
            });
        }

        let filter = {
            is_active:1,
        }

        getLangs(filter);

        const refeshList = async () => {
            emit("refetch-data");
        };

        const {
            refFormObserver,
            getValidationState,
            resetForm,
        } = formValidation(resetData)

        return {
            refFormObserver,
            getValidationState,
            resetForm,
            resetData,
            getData,
            toast,
            langs,
            changeTitle,
            getLangs,
            refeshList,
            onSubmit,
            Data,
        }
    }
}
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/quill.scss";
</style>